﻿
angular.module('fliptoWeb')
    .directive('ftHoverClass', [function () {

        return {
            restrict: 'A',
            scope: {
                hoverClass: '@ftHoverClass'
            },
            link: function (scope, element, attrs) {

                element.on('mouseenter', () => toggleHoverClass(true));
                element.on('mouseleave', () => toggleHoverClass(false));

                scope.$on("$destroy", () => {
                    element.off("mouseenter", toggleHoverClass);
                    element.off("mouseleave", toggleHoverClass);
                });

                function toggleHoverClass(isOn) {
                    if (isOn) {
                        element.addClass(scope.hoverClass);
                    } else {
                        element.removeClass(scope.hoverClass);
                    }
                }

            }
        };
    }]);